import React from 'react';
import { render, fireEvent, act } from '@testing-library/react';
import ChatBubbleWrapper from '../ChatBubble';

// Mock lodash delay
global._ = {
  delay: (fn, ms) => setTimeout(fn, ms),
};

const sampleAnnouncements = [
  {
    uuid: 'bubble-1',
    body: 'Hello from chat bubble!',
    display_name: 'Admin',
    reaction_counts: { '👍': 5, '❤️': 3 },
  },
];

const defaultProps = {
  announcements: sampleAnnouncements,
  sendAnnouncementEvent: jest.fn(),
  localReactions: [],
};

describe('ChatBubbleWrapper', () => {
  beforeEach(() => {
    jest.clearAllMocks();
    jest.useFakeTimers();
    window.__a_chat_bubble_mounted = false;
    window.__a_chat_bubble_shown = false;
  });

  afterEach(() => {
    jest.useRealTimers();
  });

  it('renders null when no announcements', () => {
    const { container } = render(
      <ChatBubbleWrapper announcements={[]} sendAnnouncementEvent={jest.fn()} localReactions={[]} />
    );
    expect(container.innerHTML).toBe('');
  });

  it('renders the chat bubble when announcements exist', () => {
    const { getByText } = render(<ChatBubbleWrapper {...defaultProps} />);
    expect(getByText('Hello from chat bubble!')).toBeTruthy();
  });

  it('renders the display name', () => {
    const { getByText } = render(<ChatBubbleWrapper {...defaultProps} />);
    expect(getByText('Admin')).toBeTruthy();
  });

  it('renders reactions with counts', () => {
    const { getByText } = render(<ChatBubbleWrapper {...defaultProps} />);
    expect(getByText('👍')).toBeTruthy();
    expect(getByText('5')).toBeTruthy();
    expect(getByText('❤️')).toBeTruthy();
    expect(getByText('3')).toBeTruthy();
  });

  it('shows bubble after delay on initial mount', () => {
    const { container } = render(<ChatBubbleWrapper {...defaultProps} />);
    expect(container.querySelector('.a-chat-bubble-show')).toBeNull();

    act(() => {
      jest.advanceTimersByTime(800);
    });

    expect(container.querySelector('.a-chat-bubble-show')).toBeTruthy();
  });

  it('toggles bubble visibility on icon click', () => {
    // Start already mounted/shown
    window.__a_chat_bubble_mounted = true;
    window.__a_chat_bubble_shown = true;

    const { container } = render(<ChatBubbleWrapper {...defaultProps} />);
    expect(container.querySelector('.a-chat-bubble-show')).toBeTruthy();

    const iconButton = container.querySelector('.a-chat-bubble-icon');
    fireEvent.click(iconButton);
    expect(container.querySelector('.a-chat-bubble-show')).toBeNull();

    fireEvent.click(iconButton);
    expect(container.querySelector('.a-chat-bubble-show')).toBeTruthy();
  });

  it('calls sendAnnouncementEvent when reaction is clicked', () => {
    const sendEvent = jest.fn();
    const { getByText } = render(
      <ChatBubbleWrapper {...defaultProps} sendAnnouncementEvent={sendEvent} />
    );

    fireEvent.click(getByText('👍').closest('.a-chat-bubble-reaction'));
    expect(sendEvent).toHaveBeenCalledWith('bubble-1', '👍');
  });

  it('does not fire reaction click when already active', () => {
    const sendEvent = jest.fn();
    const localReactions = [{ uuid: 'bubble-1', events: ['👍'] }];

    const { getByText } = render(
      <ChatBubbleWrapper
        {...defaultProps}
        sendAnnouncementEvent={sendEvent}
        localReactions={localReactions}
      />
    );

    const thumbsReaction = getByText('👍').closest('.a-chat-bubble-reaction');
    expect(thumbsReaction.classList.contains('a-chat-bubble-reaction-active')).toBe(true);

    fireEvent.click(thumbsReaction);
    expect(sendEvent).not.toHaveBeenCalled();
  });

  it('does not show bubble without display_name', () => {
    const announcements = [{ ...sampleAnnouncements[0], display_name: null }];
    const { queryByText } = render(
      <ChatBubbleWrapper {...defaultProps} announcements={announcements} />
    );
    expect(queryByText('Admin')).toBeNull();
  });
});
